import { LandlordPaymentModel } from '@evimo/types/enums/landlord-payment-model';
import { OemRateWindowUnit } from '@evimo/types/enums/oem-rate-window-unit';
import { SlaContractStatus } from '@evimo/types/enums/sla-contract-status';
import {
  SLA_CONTRACT_STATUS_COLORS,
  SLA_PAYMENT_MODEL_COLORS,
  SLA_RATE_WINDOW_UNIT_COLORS,
} from '@/app/landing/sla/shared/utils/sla-status.utils';

export const SLA_STATUS_SELECT_OPTIONS = Object.values(SlaContractStatus).map(
  (value) => ({
    value,
    color: SLA_CONTRACT_STATUS_COLORS[value],
    labelKey: value,
  }),
);

export const SLA_PAYMENT_MODEL_SELECT_OPTIONS = Object.values(
  LandlordPaymentModel,
).map((value) => ({
  value,
  color: SLA_PAYMENT_MODEL_COLORS[value],
  labelKey: value,
}));

export const SLA_RATE_WINDOW_UNIT_SELECT_OPTIONS = Object.values(
  OemRateWindowUnit,
).map((value) => ({
  value,
  color: SLA_RATE_WINDOW_UNIT_COLORS[value],
  labelKey: value,
}));
